import { auth } from "./auth";
import {
	addUploadAdministration,
	getUploadAdministration,
	editUploadAdministration,
	deleteRegistrationHelp,
	deleteStatementOfUnderstanding
} from "./admin/uploadAdministration/UploadAdministration";
import { alertSubscriptionManagement } from "./admin/alertSubscriptionManagement/alertSubscriptionManagement";
import {
	addThemeColor,
	editThemeColor,
	getThemeColors,
	getThemeColorByGroupNumber
} from "./admin/employeePageDesign/EmployeePageDesign";
import {
	getLogoSettings,
	getLogoSettingsByGroupNumber,
	addLogoSettings,
	editLogoSettings
} from "./admin/employeePageDesign/LogoSettings";
import { getGroups, group } from "./admin/group/group";
import { healthLinks } from "./admin/healthLinks/healthLinks";
import {
	toggleMemberSupport,
	toggleEmployerSupport,
	getUserById,
	editUser,
	findUserName,
	findEmail,
	getUser,
	getUserCount
} from "./user/user";
import { employeePageDesignPreview } from "./admin/employeePageDesign/EmployeePageDesignPreview";
import { logoSettingsPreview } from "./admin/employeePageDesign/LogoSettingsPreview";
import { notification } from "./notification/Notification";
import { assignGroupsAndLocations } from "./admin/assignGroups/AssignGroups";
import { announcements } from "./admin/announcements/announcements";
import { groupMemberEmployee } from "./groups/member/employee/employee";
import { groupMemberDependent } from "./groups/member/dependent/dependent";
import { OTP } from "./OTP/OTP";
import { find } from "./global/find";
import { signUp } from "./admin/signUp/signUp";
import { groupMember } from "./groups/member/member";
import { bulkUploadMapping } from "./groups/member/bulkUploadMapping/clientSheetMapping";
import { getEachUser, groupOwner } from "./user/users";
// import { member } from "./member/member";
import { groupBranding } from "./admin/group/groupBranding";
import { member } from "./member";
import { plan } from "./plan/plan";
import {
	getOpenEnrollmentEmployee,
	getVEBOpenEnrollmentEmployee,
	openEnrollment
} from "./openEnrollment/openEnrollment";
import { approveWaivedEnrollment, enrollment } from "./enrollment/enrollment";
import { pages } from "./pages";
import { reports } from "./reports";
import { personalChange } from "./personalChange/personalChange";
import {
	getClaimList,
	getClaimStatusDetails,
	getClaimStatusDetailsV2,
	getEOBDetails,
	getEOBDetailsV2,
	getEOBDetailsV3,
	getEOBDetailsWithCheckNumber,
	testGetClaimStatusDetailsV2
} from "./claim/claimList";
import { redirection } from "./redirection/redirection";
import { AddAutoApproveEnrollment } from "./enrollment/autoApproveEnrollment";
import { getCreateDependentRequest } from "./dependentChangeRequest/dependentChangeRequest";
import { approveCreateDependentRequest } from "./dependentChangeRequest/approveCreateDependentRequest";

// Location
import { addLocation } from "./location/addLocation";
import { getParticularLocation } from "./location/getParticularLocation";
import { editParticularLocation } from "./location/editParticularLocation";
import { enrollerReports } from "./enrollerReport";
import { agent } from "./agent";

// check date
import { checkDate } from "./checkDate/checkDate";
import { dataIntegrityReports } from "./dataIntegrityReports";
import { getMemberWaivedBenefits } from "./enrollment/getwaivedBenefits";
import { editActionTakenAgainstWaive } from "./enrollment/editActionTakenAgainstWaive";
import { getCountNotesForEachMember } from "./notes/getCountNotesForEachMember";
import { getCurrentBenefitById } from "./enrollment/getCurrentBenefitById";
import { emailUpdate } from "./memberInfoUpdate/emailUpdate";
import { SSNUpdate } from "./memberInfoUpdate/SSNUpdate";
import { locationNumberUpdate } from "./memberInfoUpdate/locationNumberUpdate";
import { buyUpEligibilityUpdate } from "./memberInfoUpdate/buyUpEligibilityUpdate";
import { hireDateUpdate } from "./memberInfoUpdate/hireDateUpdate";
import { dateofBirth } from "./memberInfoUpdate/dateofBirthUpdate";
import {
	benefitRecalculation,
	benefitRecalculationAfterRemovingDependent
} from "./benefitRecalculation/benefitRecalculation";
import { getHistoryBenefitsV2 } from "./enrollment/benefitHistory";
import { editMemberCredentials } from "./auth/editMemberCredentials/editMemberCredentials";
import { getBenefitSummaryPlanHighlights } from "./benefitSummary/getBenefitSummaryPlanHighlights";
import { getBenefitSpecificEnrollmentInsights } from "./benefitSummary/getBenefitSpecificEnrollmentInsights";
import { getBenefitMemberProjection } from "./benefitSummary/getBenefitMemberProjection";
import { sendTextMessage } from "./twilioMessage/twilioMessaage";
import { documentSharing } from "./admin/documentAdminstration/DocumentAdminstration";
import { getProvidersData } from "./provider/get.provider.allData";
import { getProviderDetailsByTaxId } from "./provider/getProviderDetailsByTaxId";
import { addProviders } from "./provider/addProvider";
import { updateProviderByTaxId } from "./provider/updateProvidersByTaxId";
import { corePremiumChangeReport, vebPremiumChangeReport } from "./reports/premiumChangeReport";
import {
	postPremiumRecalculationForm,
	postPremiumValidationForm
} from "./premiumRecalculation/postPremiumRecalculationForm";
import { getPremiumRecalculation } from "./premiumRecalculation/getPremiumRecalculation";
import { getTerminationReason } from "./terminationReason/terminationReason";
import { getCoreEnrollmentsYearlyStatus } from "./benefitSummary/getCoreEnrollmentStatusYearly";
import { viewSSNAddLog } from "./SSN/viewSSNLog";
// import { createGroup, deleteGroup, getGroupByGroupNumber } from "./admin/group/createGroup";
import { add } from "date-fns";
import { planDesign } from "./planDesign/planDesign";
import { getAlternateID } from "./alternateID/alternateID";

export const api = {
	auth: {
		createGroupOwner: auth.createGroupOwner,
		createEmployee: auth.createEmployee,
		createDependent: auth.createDependent,
		ownerSignUp: auth.ownerSignUp,
		memberSignUp: auth.memberSignUp,
		login: auth.login,
		forgetUserName: auth.forgetUserName,
		generatePasswordLink: auth.generatePasswordLink,
		changeForgetPassword: auth.changeForgetPassword,
		editGroupOwner: auth.editGroupOwner,
		changePassword: auth.changePassword,
		editUserProfileInformation: auth.editUserProfileInformation,
		enableAndDisableUserById: auth.enableAndDisableUserById,
		memberChangePassword: auth.memberChangePassword,
		editMemberCredentials: editMemberCredentials,
		editClaimVisibilityById: auth.editClaimVisibilityById
	},
	OTP: {
		sendToEmail: OTP.sendOTPToEmail,
		verifyOTP: OTP.verifyOTP
	},
	find: {
		findEmail: find.findEmail,
		findMemberEmail: find.findMemberEmail,
		findGroupOwnerEmail: find.findGroupOwnerEmail,
		findUserName: find.findUserName,
		findMemberId: find.findMemberId,
		findSSN: find.findSSN,
		findGroupOwnerSSN: find.findGroupOwnerSSN,
		findMemberSSN: find.findMemberSSN,
		findLocation: find.findLocation,
		checkPersonAlreadyExists: find.checkPersonAlreadyExists
	},
	users: {
		getEachUser
	},
	groupOwner: {
		getGroupOwnerByAuth: groupOwner.getGroupOwnerByAuth,
		getGroupOwnerCount: groupOwner.getGroupOwnerCount,
		getGroupOwnerById: groupOwner.getGroupOwnerById,
		updateUserPermissionManagement: groupOwner.updateUserPermissionManagement
	},
	member: {
		getMembersByEmployeeSSN: member.getMembersByEmployeeSSN,
		getExistsMemberEnrollemnt: member.getExistsMemberEnrollemnt,
		getDependentBySSNWithEmployee: member.getDependentBySSNWithEmployee,
		editEmployeeInformationById: member.editEmployeeInformationById,
		editContactInformationById: member.editContactInformationById,
		editDependentProfileInformationById: member.editDependentProfileInformationById,
		editDependentContactInformationById: member.editDependentContactInformationById,
		termEmployment: member.termEmployment,
		reinstateEmployment: member.reinstateEmployment,
		rehireEmployment: member.rehireEmployment,
		getMemberActivityLogBySSN: member.getMemberActivityLogBySSN
	},
	paycheck: {
		addEmployment: member.addEmployment,
		getEmployeeAndAssignedLocations: member.getEmployeeAndAssignedLocations,
		getEmployeeAndPaycheckWithAssignedLocations: member.getEmployeeAndPaycheckWithAssignedLocations,
		addPaycheck: member.addPaycheck,
		getPaycheckByEmployeeSSN: member.getPaycheckByEmployeeSSN,
		getEmployeeAndPaycheckByEmployeeSSN: member.getEmployeeAndPaycheckByEmployeeSSN
	},
	group: {
		getGroups: group.getGroups,
		getGroup: group.getGroup,
		getGroupAndLocation: group.getGroupAndLocation,
		getGroupCount: group.getGroupCount,
		getGroupSpecificAllLocations: group.getGroupSpecificAllLocations,
		createGroup: group.createGroup,
		getGroupByGroupNumber: group.getGroupByGroupNumber,
		editGroup: group.editGroup,
		deleteGroup: group.deleteGroup,
		updateGroupStatus: group.updateGroupStatus
	},
	location: {
		addLocation: addLocation,
		getParticularLocation: getParticularLocation,
		editParticularLocation: editParticularLocation
	},
	assignGroupsAndLocation: {
		getAssignedGroupsAndLocations: assignGroupsAndLocations.getAssignedGroupsAndLocations,
		assignGroups: assignGroupsAndLocations.assignGroups,
		assignLocations: assignGroupsAndLocations.assignLocations,
		assignAllGroups: assignGroupsAndLocations.assignAllGroups,
		assignAllLocations: assignGroupsAndLocations.assignAllLocations,
		getAssignedGroups: assignGroupsAndLocations.getAssignedGroups,
		getAssignedGroupsCount: assignGroupsAndLocations.getAssignedGroupsCount,
		assignSelectedLocationsToTheGroup: assignGroupsAndLocations.assignSelectedLocationsToTheGroup
	},
	uploadAdminstration: {
		addUploadAdministration,
		getUploadAdministration,
		editUploadAdministration,
		deleteRegistrationHelp,
		deleteStatementOfUnderstanding
	},
	employeePageDesign: {
		addThemeColor,
		editThemeColor,
		getThemeColors,
		getThemeColorByGroupNumber,
		getLogoSettings,
		getLogoSettingsByGroupNumber,
		addLogoSettings,
		editLogoSettings
	},
	healthLinks: {
		addBlog: healthLinks.addBlog,
		editBlog: healthLinks.editBlog,
		assignGroup: healthLinks.assignGroups,
		addHealthLink: healthLinks.addHealthLink,
		getHealthLinks: healthLinks.getHealthLinks,
		editHealthLink: healthLinks.editHealthLink,
		deleteHealthLinkById: healthLinks.deleteHealthLinkById,
		getHealthLinkById: healthLinks.getHealthLinkById,
		getGroups: healthLinks.getGroups,
		assignAllGroups: healthLinks.assignAllGroups,
		assignLocations: healthLinks.assignLocations,
		getHealthLinkValidity: healthLinks.getHealthLinkValidity,
		filterHealthLinks: healthLinks.filterHealthLinks,
		countHealthLinks: healthLinks.countHealthLinks
	},
	documentSharing: {
		createFolder: documentSharing.createFolder,
		getUploadedDocumentList: documentSharing.getUploadedDocumentList,
		adminFileUpload: documentSharing.adminDocumentUpload,
		getMemberUploadedDocumentList: documentSharing.getMemberUploadedDocumentList,
		getGroupOwnerSharedDocumentMember: documentSharing.getGroupOwnerSharedDocumentMember,
		getMemberList: documentSharing.getMemberList,
		adminShareFile: documentSharing.adminShareFile,
		adminShareDocumentGroup: documentSharing.adminShareFileToGroup,
		getFolderDocumentListMember: documentSharing.getFolderDocumentListMember,
		deleteAdminDocument: documentSharing.deleteAdminDocument
	},
	alertSubscriptionManagement: {
		editAlertSubscription: alertSubscriptionManagement.editAlertSubscription,
		editBulkAlertSubscription: alertSubscriptionManagement.editBulkAlertSubscription
	},
	announcements: {
		getGroups: announcements.getGroups,
		assignGroups: announcements.assignGroups,
		assignLocations: announcements.assignLocations,
		assignAllGroups: announcements.assignAllGroups,
		assignAllLocations: announcements.assignAllLocations,
		getAnnouncementById: announcements.getAnnouncementById,
		addAnnouncement: announcements.addAnnouncement,
		editAnnouncement: announcements.editAnnouncement,
		getAnnouncements: announcements.getAnnouncements,
		deleteAnnouncementById: announcements.deleteAnnouncementById,
		filterAnnouncements: announcements.filterAnnouncements,
		countAnnouncements: announcements.countAnnouncements
	},
	user: {
		toggleMemberSupport,
		toggleEmployerSupport,
		getUserById,
		editUser,
		findUserName,
		findEmail,
		getUser,
		getUserCount,
		getAssignedPaginatedMembers: groupOwner.getAssignedPaginatedMembers,
		getMemberCount: groupOwner.getMemberCount,
		getMemberCountOfParticularGroup: groupOwner.getMemberCountOfParticularGroup,
		getAssignedGroupOwners: groupOwner.getAssignedGroupOwners,
		getEmployers: groupOwner.getEmployers,
		getPaginatedMembersByGroupAndAssignedLocation: groupOwner.getPaginatedMembersByGroupAndAssignedLocation,
		getEnrollers: groupOwner.getEnrollers
	},
	employeePageDesignPreview: {
		addThemeColor: employeePageDesignPreview.addThemeColor,
		editThemeColor: employeePageDesignPreview.editThemeColor,
		getThemeColors: employeePageDesignPreview.getThemeColors,
		getThemeColorByGroupId: employeePageDesignPreview.getThemeColorByGroupId,
		getThemeColorByUserId: employeePageDesignPreview.getThemeColorByUserId,
		deleteLogoSettingsByUserId: employeePageDesignPreview.deleteLogoSettingsByUserId
	},
	logoSettingsPreview: {
		addLogoSettings: logoSettingsPreview.addLogoSettings,
		editLogoSettings: logoSettingsPreview.editLogoSettings,
		getLogoSettings: logoSettingsPreview.getLogoSettings,
		getLogoSettingsByGroupId: logoSettingsPreview.getLogoSettingsByGroupId,
		getLogoSettingsByUserId: logoSettingsPreview.getLogoSettingsByUserId,
		deleteLogoSettingsByUserIdAndGroupId: logoSettingsPreview.deleteLogoSettingsByUserIdAndGroupId,
		deleteLogoSettingsByUserId: logoSettingsPreview.deleteLogoSettingsByUserId
	},
	notification: {
		getNotificationsByUserId: notification.getNotificationsByUserId,
		setAllNotificationsAsOldByUserId: notification.setAllNotificationsAsOldByUserId,
		getNotificationCount: notification.getNotificationCount
	},
	groupMemberEmployee: {
		createEmployee: groupMemberEmployee.createEmployee,
		employeeSignUp: groupMemberEmployee.employeeSignUp,
		countAllEmployees: groupMemberEmployee.countAllEmployees,
		paginatedAllEmployee: groupMemberEmployee.paginatedAllEmployee
	},
	groupMemberDependent: {
		createDependent: groupMemberDependent.createDependent,
		dependentSignUp: groupMemberDependent.dependentSignUp
	},
	groupMember: {
		getMembersByEmployeeNumber: groupMember.getMembersByEmployeeNumber,
		getMember: groupMember.getMember
	},
	bulkUploadMapping: {
		getClientSheetMapping: bulkUploadMapping.getClientSheetMapping,
		addClientSheetMapping: bulkUploadMapping.addClientSheetMapping
	},
	groupBranding: {
		addGroupBranding: groupBranding.addGroupBranding,
		editGroupBranding: groupBranding.editGroupBranding,
		deleteGroupBranding: groupBranding.deleteGroupBranding
	},
	plan: {
		getPlans: plan.getPlans,
		addPlan: plan.addPlan,
		addCorePlan: plan.addCorePlan,
		addVEBPlan: plan.addVEBPlan,
		updateVEBPlan: plan.updateVEBPlan,
		addPremiumAmountToVEBPlan: plan.addPremiumAmountToVEBPlan,
		terminatePlan: plan.terminatePlan,
		togglePlanStatus: plan.togglePlanStatus,
		getPlansByStatus: plan.getPlansByStatus,
		getVEBPlans: plan.getVEBPlans,
		getParticularPlans: plan.getParticularPlans,
		updatePlanDocument: plan.updateVEBPlanDocument,
		updateVEBPlanOrder: plan.updateVEBPlanOrder,
		getPlansWithGroupInformation: plan.getPlansWithGroupInformation
	},
	openEnrollment: {
		allOpenEnrollment: openEnrollment.allOpenEnrollment,
		getEmployeeWithOpenEnrollmentStartWith: openEnrollment.getEmployeeWithOpenEnrollmentStartWith,
		getEmployeeWithVEBOpenEnrollmentStartWith: openEnrollment.getEmployeeWithVEBOpenEnrollmentStartWith,
		specificOpenEnrollment: openEnrollment.specificOpenEnrollment,
		verifyBulkOpenEnrollment: openEnrollment.verifyBulkOpenEnrollment,
		getOpenEnrollments: openEnrollment.getOpenEnrollments,
		specificVEBOpenEnrollment: openEnrollment.specificVEBOpenEnrollment,
		allVEBOpenEnrollment: openEnrollment.allVEBOpenEnrollment,
		getOpenEnrollmentStatus: openEnrollment.getOpenEnrollmentStatus,
		getVEBOpenEnrollmentStatus: openEnrollment.getVEBOpenEnrollmentStatus,
		getOpenEnrollmentsForEachEmployee: openEnrollment.getOpenEnrollmentsForEachEmployee,
		getVEBOpenEnrollmentsForEachEmployee: openEnrollment.getVEBOpenEnrollmentsForEachEmployee,
		getOpenEnrollmentEmployee: getOpenEnrollmentEmployee,
		getVEBOpenEnrollmentEmployee: getVEBOpenEnrollmentEmployee
	},
	enrollments: {
		getNotActiveEnrollments: enrollment.getNotActiveEnrollments,
		approveEnrollment: enrollment.approveEnrollment,
		getBenefits: enrollment.getBenefits,
		approveHOOEnrollment: enrollment.approveHOOEnrollment,
		getNotActiveEnrollmentsByGroup: enrollment.getNotActiveEnrollmentsByGroup,
		getVEBBenefits: enrollment.getVEBBenefits,
		getVEBDependentBenefits: enrollment.getVEBDependentBenefits,
		getVEBRidersByPlan: enrollment.getVEBRidersByPlan,
		getDependentBenefits: enrollment.getDependentBenefits,
		getHistoryEnrollments: enrollment.getHistoryEnrollments,
		AddAutoApproveEnrollment: AddAutoApproveEnrollment,
		termEnrollment: enrollment.termEnrollment,
		termVEBEnrollment: enrollment.termVEBEnrollment,
		getMemberWaivedBenefits,
		editActionTakenAgainstWaive,
		approveWaivedEnrollment,
		getVEBHistoryBenefits: enrollment.getVEBHistoryBenefits,
		getCurrentBenefitById,
		benefitRecalculation,
		benefitRecalculationAfterRemovingDependent,
		getHistoryBenefitsV2,
		approveDynamicEnrollment: enrollment.approveDynamicEnrollment
	},
	pages: {
		getAdminEnrollmentInitData: pages.getAdminEnrollmentInitData
	},
	reports: {
		submitApi: reports.submitApi,
		getReports: reports.getReports,
		getReportLogs: reports.getReportLogs,
		censusReport: reports.censusReport,
		locationEmployeeReport: reports.locationEmployeeReport,
		dependentReport: reports.dependentReport,
		totalDeductionReport: reports.totalDeductionReport,
		planDeductionReport: reports.planDeductionReport,
		VEBDeductionReport: reports.VEBDeductionReport,
		VEBEmploymentTerminatedReport: reports.VEBEmploymentTerminatedReport,
		benefitChangesReport: reports.benefitChangesReport,
		employeeInfoChangesReport: reports.employeeInfoChangesReport,
		personalChangeReport: reports.personalChangeReport,
		employeeTermination: reports.employeeTermination,
		wltComparisonReport: reports.wltComparisonReport,
		VEBWaivedBenefitsReport: reports.VEBWaivedBenefitsReport,
		activePlanForEmployeeReport: reports.activePlanForEmployeeReport,
		remittanceReport: reports.remittanceReport,
		activePaycheckReport: reports.activePaycheckReport,
		activeHealthPlanAndClinicCardForMemberReport: reports.activeHealthPlanAndClinicCardForMemberReport,
		VEBBillingReport: reports.VEBBillingReport,
		coreActiveEnrollmentsForYOEReport: reports.coreActiveEnrollmentsForYOEReport,
		VEBActiveEnrollmentsForYOEReport: reports.VEBActiveEnrollmentsForYOEReport,
		corePreviouslyActiveCurrentlyWaivedForYOEReport: reports.corePreviouslyActiveCurrentlyWaivedForYOEReport,
		VEBPreviouslyActiveCurrentlyWaivedForYOEReport: reports.VEBPreviouslyActiveCurrentlyWaivedForYOEReport,
		corePremiumChangeReport,
		vebPremiumChangeReport,
		coreActionTakenOrNotTakenReport: reports.coreActionTakenOrNotTakenReport,
		VEBActionTakenOrNotTakenReport: reports.VEBActionTakenOrNotTakenReport,
		wltInfoComparisonReport: reports.wltInfoComparisonReport
	},
	enrollerReports: {
		enrollerReport: enrollerReports.enrollerReport,
		coreEnrollerReport: enrollerReports.coreEnrollerReport
	},
	groupReport: {
		invalidStateForMemberReport: dataIntegrityReports.groupReports.invalidStateForMemberReport,
		invalidZIPForMemberReport: dataIntegrityReports.groupReports.invalidZIPForMemberReport,
		notExistMemberLocationReport: dataIntegrityReports.groupReports.notExistMemberLocationReport,
		activeGroupPlanNullEffectiveDateReport: dataIntegrityReports.groupReports.activeGroupPlanNullEffectiveDateReport
	},
	dataIntegrityReport: {
		emptyBenefitAmountReport: dataIntegrityReports.VEBReports.emptyBenefitAmountReport,
		emptyRiderBenefitAmountReport: dataIntegrityReports.VEBReports.emptyRiderBenefitAmountReport,
		invalidSubPlanReport: dataIntegrityReports.VEBReports.invalidSubPlanReport,
		invalidMemberSSNFromVEBEnrollmentReport:
			dataIntegrityReports.VEBReports.invalidMemberSSNFromVEBEnrollmentReport,
		activePaycheckLessThanOneReport: dataIntegrityReports.groupReports.activePaycheckLessThanOneReport,
		dependentMoreThanEqualTo26YearsReport: dataIntegrityReports.groupReports.dependentMoreThanEqualTo26YearsReport
	},
	agent: {
		getAgents: agent.getAgents
	},
	changeRequest: {
		getPersonalChangeRequests: personalChange.getPersonalChangeRequests,
		getCreateDependentRequest: getCreateDependentRequest,
		approveCreateDependentRequest: approveCreateDependentRequest
	},
	claim: {
		getClaimList,
		getEOBDetails,
		getEOBDetailsV2,
		getClaimStatusDetails,
		getClaimStatusDetailsV2,
		testGetClaimStatusDetailsV2,
		getEOBDetailsWithCheckNumber,
		getEOBDetailsV3
	},
	redirection: {
		redirectUser: redirection.redirectUser
	},
	checkDate: {
		checkDate: checkDate
	},
	notes: {
		getCountNotesForEachMember
	},
	providers: {
		getProvidersData: getProvidersData,
		updateProvidersByTaxID: updateProviderByTaxId,
		getProviderDetailsByTaxId,
		addProviders
	},
	memberInfoUpdate: {
		emailUpdate,
		SSNUpdate,
		locationNumberUpdate,
		buyUpEligibilityUpdate,
		hireDateUpdate,
		dateofBirth
	},
	benefitSummary: {
		getBenefitSummaryPlanHighlights,
		getBenefitSpecificEnrollmentInsights,
		getBenefitMemberProjection,
		getCoreEnrollmentsYearlyStatus
	},
	textMessage: {
		sendTextMessage: sendTextMessage
	},
	premiumRecalculation: {
		getPremiumRecalculation: getPremiumRecalculation,
		postPremiumRecalculationForm: postPremiumRecalculationForm,
		postPremiumValidationForm: postPremiumValidationForm
	},
	terminationReason: {
		getTerminationReason: getTerminationReason
	},
	viewSSNLog: {
		viewSSNAddLog: viewSSNAddLog
	},
	planDesign: {
		addPlanDesignForm: planDesign.addPlanDesignForm,
		updatePlanDesignForm: planDesign.updatePlanDesignForm
	},
	alternateID: {
		getAlternateID: getAlternateID
	}
};
